import { useState } from "react";
import { questionAnswer } from "./helper";

const Faq = () => {
  const [openId, setOpenId] = useState(null);

  return (
    <div className="right-section">
      <div className="card profile-details-section">
        <div className="card-body">
          <h4 className="mt-3" style={{ marginLeft: "8px" }}>
            Frequently Asked Questions
          </h4>
          <div className="">
            <div className="row gx-5 fill-details-section mt-2">
              {questionAnswer.map((ele, index) => {
                return (
                  <div className="col-lg-6 col-md-6 mt-4" key={index}>
                    <div
                      className="accordion accordion-faq"
                      id="accordionPanelsStayOpenExample"
                    >
                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="panelsStayOpen-headingOne"
                        >
                          <button
                            className={`accordion-button ${
                              openId === index && "collapsed"
                            }`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={index}
                            aria-expanded="true"
                            aria-controls="panelsStayOpen-collapseOne"
                            onClick={() =>
                              setOpenId(
                                openId === null
                                  ? ele?.id
                                  : openId === ele?.id
                                  ? null
                                  : ele?.id
                              )
                            }
                          >
                            {ele?.question}
                          </button>
                        </h2>
                        <div
                          id={index}
                          className={`accordion-collapse collapse ${
                            openId === index && "show"
                          }`}
                          aria-labelledby="panelsStayOpen-headingOne"
                        >
                          <div className="accordion-body">{ele?.answer}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
